module.exports = __webpack_public_path__ + "static/img/page_bg.8b41c8f2.png";